<template>
  <section style="overflow:hidden">
    <PublicNavigation :showForm="showForm" />
    <!-- Main header -->
    <section class="main-header">
      <div class="container d-flex align-items-center">
        <h1>Find your ideal <span>candidate, for free</span></h1>
        <router-link @click.native="showFormEvent('employer')" to class="btn btn-secondary cta"
          >Post a job</router-link
        >
      </div>
    </section>
    <!-- Main header end -->
    <!-- Jobs section -->
    <section class="jobs">
      <div class="container">
        <div class="row">
          <div class="col-md-4">
            <img
              class="img-fluid"
              src="../../../public/img/homepage/img-free-job-posting.png"
              alt="services"
            />
          </div>
          <div class="col-md-6 ml-auto">
            <h2>Source and recruit, your way</h2>
            <p>
              Today’s open world has changed the rules for recruiting, which is why we believe that
              job postings should be for free. But, if you want to take it to the next level, you
              can enhance your search and save time with our additional services, including active
              search, social recruiting, candidate assessment and technical testing of candidates.
              For projects on-site or remote work, you can get in touch with available candidates
              from our network of highly qualified freelancers.
            </p>
            <ul class="list-unstyled">
              <li>
                <div class="icon"><i class="fas fa-check"></i></div>
                Jobshark is a modern platform where employers meet IT professionals looking for new
                job opportunities
              </li>
              <li>
                <div class="icon"><i class="fas fa-check"></i></div>
                In today’s modern world we believe that job posting should be for free
              </li>
              <li>
                <div class="icon"><i class="fas fa-check"></i></div>
                If you are interested in additional services like active search, qualification,
                international search, nearshoring or contracting freelancers for short-time projects
                we are happy to discuss that further
              </li>
            </ul>
            <div>
              <!--               <router-link @click.native="showFormEvent('employer')" to class="btn btn-secondary"
                >Post free job ad</router-link
              > -->
              <router-link :to="{ name: 'recruiting-services' }" class="btn btn-secondary ml-3"
                >Headhunting services</router-link
              >
              <CustomMainModal @close="showModal = false" v-show="showModal">
                <template v-slot:header>
                  <h5 v-if="!showVerification">{{ 'Sign Up as Employer' }}</h5>
                  <h5 v-else>{{ 'Verification' }}</h5>
                </template>

                <form
                  @submit.prevent="getCaptcha"
                  v-show="!showVerification"
                  id="free-job-posting-employer-form"
                >
                  <section v-if="step == 1">
                    <div class="row">
                      <div class="col-12 col-lg-6 mt-4 ml-auto mr-auto mb-4">
                        <div class="multisteps-form__progress">
                          <button
                            class="multisteps-form__progress-btn js-active"
                            type="button"
                            title="User Info"
                          >
                            Step 1
                          </button>
                          <button
                            class="multisteps-form__progress-btn"
                            type="button"
                            title="Address"
                          >
                            Step 2
                          </button>
                        </div>
                      </div>
                    </div>

                    <div class="row justify-content-center">
                      <div class="col-md-11">
                        <div class="row">
                          <div class="form-group m-label col-md-12 required">
                            <input
                              type="text"
                              id="Company"
                              v-model="postFreeJob.companyName"
                              class="form-control"
                              @keyup="validate($event)"
                              required
                              :autocomplete="false"
                            />
                            <label for="Company">Company</label>
                          </div>
                        </div>
                        <div class="row">
                          <div class="form-group m-label col-md-12 required">
                            <input
                              type="text"
                              id="street-address"
                              v-model="postFreeJob.address"
                              class="form-control"
                              @keyup="validate($event)"
                              required
                              autocomplete
                            />
                            <label for="street-address">Street Address</label>
                          </div>
                        </div>
                        <div class="row">
                          <div class="form-group m-label col-md-4 required">
                            <input
                              type="text"
                              v-model="postFreeJob.postal"
                              class="form-control"
                              id="postal-code"
                              @keyup="validate($event)"
                            />
                            <label for="postal-code">Postal Code</label>
                          </div>

                          <div class="form-group m-label filter-item col-md-8 required">
                            <v-select
                              v-model="postFreeJob.cityId"
                              label="name"
                              :options="[...getCitiesListByCountry]"
                              :reduce="res => res.id"
                              :clearable="false"
                              @change="validate($event)"
                              placeholder="City"
                              id="city"
                            >
                              <template v-slot:no-options>
                                <div style="opacity: 0.5">You must choose country first</div>
                              </template>
                            </v-select>
                            <label for="city">City</label>
                          </div>
                        </div>
                        <div class="form-group m-label-left filter-item required-right">
                          <!-- <FloatLabel label="City"> -->
                          <!--  @search="fetchOptionsForCountries" -->
                          <v-select
                            v-model="postFreeJob.countryName"
                            @input="fetchCitisByCountryId($event)"
                            :options="[...getAllCountries]"
                            label="name"
                            placeholder="Country"
                            :reduce="res => res"
                            :clearable="false"
                            required
                          ></v-select>
                          <!-- </FloatLabel> -->
                          <label for="country">Country</label>
                        </div>
                        <div class="row">
                          <div class="form-group m-label col-md-12">
                            <input
                              type="text"
                              id="Corporate-website"
                              v-model="postFreeJob.corporateWebsite"
                              class="form-control"
                            />
                            <label for="Corporate-website">Corporate website</label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>

                  <section v-if="step == 2">
                    <div class="row">
                      <div class="col-12 col-lg-6 mt-4 ml-auto mr-auto mb-5">
                        <div class="multisteps-form__progress">
                          <button
                            class="multisteps-form__progress-btn"
                            type="button"
                            title="User Info"
                          >
                            Step 1
                          </button>
                          <button
                            class="multisteps-form__progress-btn js-active"
                            type="button"
                            title="Address"
                          >
                            Step 2
                          </button>
                        </div>
                      </div>
                    </div>

                    <div class="row justify-content-center">
                      <div class="col-md-11">
                        <div class="row">
                          <div class="form-group m-label col-md-6 required">
                            <input
                              @keyup="validate($event)"
                              type="text"
                              id="first-name"
                              v-model="postFreeJob.firstName"
                              class="form-control"
                              required
                            />
                            <label for="first-name">First Name</label>
                          </div>
                          <div class="form-group m-label col-md-6 required">
                            <input
                              type="text"
                              id="last-name"
                              v-model="postFreeJob.lastName"
                              class="form-control"
                              @keyup="validate($event)"
                              required
                            />
                            <label for="last-name">Last Name</label>
                          </div>
                        </div>
                        <div class="row">
                          <div class="form-group m-label col-md-12 required">
                            <div>
                              <input
                                type="email"
                                id="email"
                                v-model="postFreeJob.email"
                                class="form-control"
                                @keyup="validate($event)"
                                :class="emailNotFalid ? 'is-invalid' : ''"
                                required
                              />
                              <label for="email">Company Email</label>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="form-group m-label col-md-12 required">
                            <div>
                              <input
                                type="password"
                                id="post-free-job-password"
                                class="form-control"
                                v-model="postFreeJob.password"
                                @keyup="validate($event)"
                                required
                                placeholder="Minimum 8 characters"
                              />
                              <label for="post-free-job-password">Password</label>
                            </div>
                          </div>
                          <div class="form-group m-label col-md-4">
                            <div
                              class="form-control customform no-hor"
                              style="height: 48px; position: relative"
                            >
                              <v-select
                                @input="addCountryCode(postFreeJob.phone_code)"
                                style="position: absolute; left: 0; top: 6px; width: 100%"
                                v-model="postFreeJob.phone_code"
                                :options="
                                  [...getAllCountries].map(
                                    item => `${item.phone_code} ${item.name}`,
                                  )
                                "
                                :clearable="false"
                              >
                                <template v-slot:option="option">
                                  {{ option.label }}
                                </template>
                              </v-select>
                            </div>
                            <label for="country-code">Country Code</label>
                          </div>
                          <div class="form-group m-label col-md-8 required">
                            <input
                              type="tel"
                              id="phone"
                              v-model="postFreeJob.phone"
                              class="form-control"
                              @keyup="validate($event)"
                              required
                            />
                            <label for="phone">Phone Number</label>
                          </div>
                          <div class="form-group col-md-12 mb-0">
                            <div class="agreement">
                              <div class="custom-control custom-checkbox">
                                <input
                                  v-model="postFreeJob.isAccepted"
                                  type="checkbox"
                                  class="custom-control-input"
                                  id="customCheck1"
                                />
                                <label class="custom-control-label" for="customCheck1"
                                  >I agree to
                                  <router-link
                                    target="_blank"
                                    style="text-decoration: none"
                                    :to="{ name: 'employers' }"
                                    >Jobshark's General Conditions for Employers</router-link
                                  ></label
                                >
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>
                  <!-- Nav btn's -->
                  <div class="row justify-content-center mb-5 mt-4">
                    <div class="col-6 text-center">
                      <!-- <div class="text-center mt-3 d-flex"> -->

                      <button
                        class="btn btn-primary btn-custom w-50 mr-5 prev"
                        @click="prev"
                        :disabled="step == 1 || step < 0"
                      >
                        <i class="fa fa-chevron-left mr-3"></i>Back
                      </button>
                    </div>
                    <div class="col-6 text-center">
                      <button
                        v-if="step == 2"
                        type="submit"
                        class="btn btn-success btn-custom w-50 mr-2"
                        :disabled="!canPost"
                      >
                        Sign Up
                      </button>

                      <button
                        v-else
                        type="button"
                        form="add-for-job"
                        class="btn btn-secondary btn-custom w-50"
                        :disabled="!nextStep"
                        @click="next"
                      >
                        Next
                        <i class="fa fa-chevron-right ml-3"></i>
                      </button>
                    </div>
                  </div>
                  <Spinner :isLoading="isLoading" />
                </form>
                <Verification
                  v-show="showVerification"
                  :currentEmail="postFreeJob.email"
                  @prevStep="toggleForms()"
                />
              </CustomMainModal>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!--End of Jobs -->
    <div class="row">
      <div class="col-md-6 mb-5 mt-5 mx-auto">
        <div class="ratio ratio-16x9">
          <iframe
            src="https://www.youtube.com/embed/1dALsho9t-Y?si=4WXp0rYKiBAGm2Lz"
            title="Jobshark Video"
            allowfullscreen
          ></iframe>
        </div>
      </div>
    </div>
    <!-- Middle Orange Section -->
    <section class="mid-section">
      <div class="container">
        <h2>
          <img src="../../../public/img/homepage/icon-interview.png" alt="recruiting services" />
          Professional recruiting services
        </h2>
        <p>
          Enhance your candidate search and outsource part of the candidate assessment with our
          range of recruitment services, tailored to your needs and budget.
        </p>
        <div class="text-center">
          <router-link :to="{ name: 'recruiting-services' }" class="btn btn-secondary"
            >Learn more</router-link
          >
        </div>
      </div>
    </section>
    <!-- End of orange section -->
    <section class="statistics">
      <div class="container">
        <h2 class="text-center">Top competences</h2>
        <ul class="list-inline d-flex justify-content-between">
          <li
            v-for="(competence, index) in topCompetences"
            v-bind:key="competence.id"
            class="list-inline-item d-flex align-items-center"
          >
            <div class="text">
              <i v-if="competence.devicon !== null" :class="`${competence.devicon} colored`"></i>
              <img v-else src="/img/comstream.svg" alt="Jobshark logo" />
              <span>
                <number
                  animationPaused
                  :ref="`col${index}`"
                  :format="theFormat"
                  :to="competence.counter"
                  :duration="3"
                  easing="Power1.easeOut"
                  @complete="completed"
                  @click="playAnimation(`col${index}`)"
                />
              </span>
              <IntersectionObserver
                v-if="index === 0"
                sentinal-name="sentinal-name"
                @on-intersection-element="onIntersectionElement"
              ></IntersectionObserver>
              {{ competence.name }}
            </div>
          </li>
        </ul>
      </div>
    </section>
    <!-- Footer -->
    <Footer />
    <!-- End Footer -->
  </section>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import PublicNavigation from '@/components/Navigations/PublicNavigation';
import Footer from '@/components/Navigations/PublicFooter';
import Verification from './VerificationCodeEmployer.vue';
import CustomMainModal from '@/components/Modals/CustomMainModal';
import IntersectionObserver from '@/components/common/IntersectionObserver';
import Spinner from '../../components/common/LoadingSpinner/Spinner';
import titleMixin from '../../mixins/titleMixin';
import axios from 'axios';

export default {
  mixins: [titleMixin],
  title() {
    return 'Post your IT Job for Free | Jobshark';
  },
  description() {
    return "It's free of charge to post your IT job on Jobshark. We can boost the process by providing professional services like headhunting and qualification of candidates.";
  },
  canonicalLink() {
    return 'https://jobshark.eu/free-job-posting';
  },
  components: {
    Spinner,
    Footer,
    Verification,
    CustomMainModal,
    PublicNavigation,
    IntersectionObserver,
  },
  data: () => ({
    showForm: {
      formType: '',
      count: 0,
    },
    reToken: '',
    inViewport: {
      now: false, // Is some part of the component currently in the viewport?
      fully: false, // Is the component completely in the viewport?
      above: false, // Is any part of the component above the viewport?
      below: false, // Is any part of the component below the viewport?
    },
    showModal: false,
    step: 1,
    isLoading: false,
    showVerification: false,
    nextStep: false,
    validCity: false,
    validCountry: false,
    canPost: false,
    emailNotFalid: false,
    emailValidated: false,
    phoneValidated: false,
    postFreeJob: {
      phone: '',
      email: '',
      companyName: '',
      countryId: '',
      address: '',
      postal: '',
      city: '',
      cityId: '',
      countryName: '',
      corporateWebsite: '',
      firstName: '',
      lastName: '',
      password: '',
      phone_code: '',
      isAccepted: false,
      campaign_id: null,
      campaign_medium: null,
      campaign_name: null,
      campaign_source: null,
    },
    topCompetences: [],
  }),

  watch: {
    postFreeJob: {
      handler(val) {
        if (val.companyName && val.countryId && val.address && val.postal && val.cityId) {
          this.nextStep = true;
        } else {
          this.nextStep = false;
        }
        if (
          this.nextStep &&
          val.firstName &&
          val.lastName &&
          val.password.length >= 8 &&
          val.phone &&
          val.email.length > 0
        ) {
          this.canPost = true;
        } else {
          this.canPost = false;
        }
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions([
      'retrieveCitiesListByCountryId',
      'retrieveCompetencesList',
      'retrieveLanguagesList',
      'retrieveAllCountries',
      'searchLocationByName',
    ]),

    showFormEvent(type) {
      this.showForm.formType = type;
      this.showForm.count++;
    },

    toggleForms() {
      this.showVerification = false;
    },

    addCountryCode(code) {
      this.postFreeJob.phone_code = code.replace(/[0-9+]/g, '');
      this.postFreeJob.phone = code.substring(0, code.indexOf(' ')) + ' ';
    },

    validateEmail(email) {
      const emailRe = /^(([^<>()[\]\\.,;:#/\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      // const emailRe = /^(([^<>()\[\]\\.,;:#/\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (email.length > 0) {
        if (emailRe.test(email)) {
          this.emailNotFalid = false;
          this.emailValidated = true;
        } else {
          this.emailNotFalid = true;
          this.emailValidated = false;
        }
      }
    },

    /*     allowNext() {
      if (
        this.postFreeJob.companyName.length > 0 &&
        this.postFreeJob.address.length > 0 &&
        this.postFreeJob.postal.length &&
        this.validCity &&
        this.validCountry
      ) {
        this.nextStep = true;
      } else {
        this.nextStep = false;
      }
    }, */

    validate(el) {
      if (el.target.required === true && el.target.value === '') {
        el.target.classList.add('is-invalid');
      } else {
        el.target.classList.remove('is-invalid');
      }

      if (el.target.type === 'email') {
        this.validateEmail(this.postFreeJob.email);
      }

      if (el.target.type === 'password' && el.target.value.length < 8) {
        el.target.classList.add('is-invalid');
      } else {
        el.target.classList.remove('is-invalid');
      }
    },

    getDefaultCountry() {
      axios
        .get(`${process.env.VUE_APP_API_URL}/common/address/getaddressbyip`, {
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
        })
        .then(({ data }) => {
          console.log(data);
          this.postFreeJob.countryName = data.country_name;
          this.postFreeJob.countryId = data.country_id;
          this.postFreeJob.phone_code = data.country_name;
          this.postFreeJob.phone = `${data.phone_code} `;
          this.postFreeJob.city = data.city_name;
          this.postFreeJob.cityId = data.city_id;
          this.postFreeJob.postal = data.city_postal_code;
          this.retrieveCitiesListByCountryId({ id: this.postFreeJob.countryId });
        });
    },

    fetchCitisByCountryId(e) {
      this.postFreeJob.city = '';
      this.postFreeJob.cityId = '';
      this.postFreeJob.countryName = e.name;
      this.postFreeJob.countryId = e.id;
      this.retrieveCitiesListByCountryId({ id: this.postFreeJob.countryId });
    },
    setCityModel(e) {
      this.postFreeJob.cityId = e;
    },
    onIntersectionElement() {
      const colsList = Object.keys(this.$refs);

      colsList.forEach(item => {
        this.$refs[item][0].play();
      });
    },
    theFormat(number) {
      return number.toFixed(0);

      /* return number.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ','); */
    },
    completed() {
      //  console.log('Animation ends!');
    },
    playAnimation(col) {
      this.$refs[col].play();
    },
    saveAd() {
      /* TODO:: save ad function */
    },
    saveAndPublishAd() {
      /* TODO::  save and publish function*/
    },
    next() {
      if (this.step < 2) {
        this.step++;
      }
    },
    prev() {
      this.step--;
    },
    getTopTenCompetences() {
      axios
        .get(`${process.env.VUE_APP_API_URL}/common/competence/topcompetences`, {
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
        })
        .then(({ data }) => {
          if (window.innerWidth >= 601 && window.innerWidth <= 768) {
            this.topCompetences = data.slice(0, -2);
          }
          if (window.innerWidth <= 601) {
            this.topCompetences = data.slice(0, -2);
          }
          if (window.innerWidth >= 769 && window.innerWidth <= 992) {
            this.topCompetences = data.slice(0, -4);
          }
          if (window.innerWidth > 1000) {
            this.topCompetences = data.slice(0, -1);
          }
        });
    },

    getCaptcha() {
      let vm = this;
      const REG = () => this.registerEmployer();
      grecaptcha
        .execute('6LdyDhspAAAAAJWVsgRkufJ8fAJBeSDpWDPUsvAn', { action: 'submit' })
        .then(function(token) {
          vm.reToken = token;
          REG();
        });
    },
    registerEmployer() {
      if (!this.postFreeJob.isAccepted) {
        this.$toasted.error(
          `Please agree to Jobshark's General Conditions for Employers to register`,
          {
            theme: 'bubble',
            icon: 'fa-check-circle',
            position: 'bottom-right',
            duration: 5000,
          },
        );
        return false;
      }
      this.isLoading = true;
      axios({
        method: 'post',
        url: `${process.env.VUE_APP_API_URL}/manager/auth/register`,
        data: {
          email: this.postFreeJob.email,
          password: this.postFreeJob.password,
          company_name: this.postFreeJob.companyName,
          first_name: this.postFreeJob.firstName,
          last_name: this.postFreeJob.lastName,
          city_id: this.postFreeJob.cityId,
          country_id: this.postFreeJob.countryId,
          street_address: this.postFreeJob.address,
          website: this.postFreeJob.corporateWebsite,
          phone_number: this.postFreeJob.phone,
          country_code: this.postFreeJob.phone_code,
          postal_code: this.postFreeJob.postal,
          privacy: this.postFreeJob.isAccepted,
          'g-recaptcha-response': this.reToken,
          campaign_id: this.postFreeJob.campaign_id,
          campaign_medium: this.postFreeJob.campaign_medium,
          campaign_name: this.postFreeJob.campaign_name,
          campaign_source: this.postFreeJob.campaign_source,
        },
      })
        .then(response => {
          this.isLoading = false;
          this.showVerification = true;
          localStorage.setItem('uuid', response.data.id);
          localStorage.setItem('acc', 'manager');
        })
        .catch(err => {
          this.isLoading = false;
          this.$toasted.error(`${err.response.data.message}`, {
            theme: 'bubble',
            icon: 'fa-check-circle',
            position: 'bottom-right',
            duration: 5000,
          });
        });
    },
    getCampainParams() {
      if (this.$route.query.utm_id) {
        this.postFreeJob.campaign_id = this.$route.query.utm_id;
      }
      if (this.$route.query.utm_medium) {
        this.postFreeJob.campaign_medium = this.$route.query.utm_medium;
      }
      if (this.$route.query.utm_campaign) {
        this.postFreeJob.campaign_name = this.$route.query.utm_campaign;
      }
      if (this.$route.query.utm_source) {
        this.postFreeJob.campaign_source = this.$route.query.utm_source;
      }
    },
  },
  computed: {
    ...mapGetters(['getAllCountries', 'getCitiesListByCountry']),
  },
  mounted() {
    this.getCampainParams();
    this.retrieveAllCountries();
    this.getTopTenCompetences();
    this.getDefaultCountry();
  },
};
</script>

<style lang="scss" scoped>
@import './src/assets/scss/_variables.scss';

.cta {
  padding: 12px 85px;
  font-size: 16px;
  font-weight: 500;
  border-radius: 6px;
}

/* Multi Step Form CSS */
.multisteps-form__progress {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(0, 1fr));
}

.multisteps-form__progress-btn {
  transition-property: all;
  transition-duration: 0.15s;
  transition-timing-function: linear;
  transition-delay: 0s;
  position: relative;
  padding-top: 20px;
  color: rgba(108, 117, 125, 0.7);
  text-indent: -9999px;
  border: none;
  background-color: transparent;
  outline: none !important;
  cursor: pointer;
}

.no-padding {
  padding-left: 8px;
  padding-top: 15px;
}

@media (min-width: 500px) {
  .multisteps-form__progress-btn {
    text-indent: 0;
  }
}

.multisteps-form__progress-btn:before {
  position: absolute;
  top: 0;
  left: 50%;
  display: block;
  width: 13px;
  height: 13px;
  content: '';
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
  transition: all 0.15s linear 0s, -webkit-transform 0.15s cubic-bezier(0.05, 1.09, 0.16, 1.4) 0s;
  transition: all 0.15s linear 0s, transform 0.15s cubic-bezier(0.05, 1.09, 0.16, 1.4) 0s;
  transition: all 0.15s linear 0s, transform 0.15s cubic-bezier(0.05, 1.09, 0.16, 1.4) 0s,
    -webkit-transform 0.15s cubic-bezier(0.05, 1.09, 0.16, 1.4) 0s;
  border: 2px solid currentColor;
  border-radius: 50%;
  background-color: #fff;
  box-sizing: border-box;
  z-index: 3;
}

.multisteps-form__progress-btn:after {
  position: absolute;
  top: 5px;
  left: calc(-50% - 13px / 2);
  transition-property: all;
  transition-duration: 0.15s;
  transition-timing-function: linear;
  transition-delay: 0s;
  display: block;
  width: 100%;
  height: 2px;
  content: '';
  background-color: currentColor;
  z-index: 1;
}

.multisteps-form__progress-btn:first-child:after {
  display: none;
}

.multisteps-form__progress-btn.js-active {
  color: #0088cc;
}

.multisteps-form__progress-btn.js-active:before {
  -webkit-transform: translateX(-50%) scale(1.2);
  transform: translateX(-50%) scale(1.2);
  background-color: currentColor;
}

.form-group {
  margin-bottom: 25px;
}

.form-group.required {
  position: relative;

  &:after {
    content: '*';
    font-size: 22px;
    position: absolute;
    top: 0px;
    right: 26px;
    color: red;
    opacity: 0.6;
  }
}

.form-group.required-right {
  position: relative;

  &:after {
    content: '*';
    font-size: 22px;
    position: absolute;
    top: 0px;
    right: 10px;
    color: red;
    opacity: 0.6;
  }
}

.form-group.required-fixed-right {
  position: relative;

  &:after {
    content: '*';
    font-size: 22px;
    position: absolute;
    top: 0px;
    right: 6px;
    color: red;
    opacity: 0.6;
  }
}

.form-group.required-fixed-drop {
  position: relative;

  &:after {
    content: '*';
    font-size: 22px;
    position: absolute;
    top: 0px;
    right: 25px;
    color: red;
    opacity: 0.6;
  }
}

.form-group.required-fixed-country {
  position: relative;

  &:after {
    content: '*';
    font-size: 22px;
    position: absolute;
    top: 0px;
    right: 8px;
    color: red;
    opacity: 0.6;
  }
}

.modal-body {
  .btn {
    margin-top: 0 !important;
    font-size: 1rem !important;
    padding: 6px 12px !important;
  }
}

.container {
  max-width: 1320px;
}

h2 {
  text-transform: uppercase;
  font-size: 28px;
  margin-bottom: 15px;
}

p {
  color: #575757;
  font-size: 16px;
  font-family: $font-family-sans-lato;
}

.main-header {
  height: 70vh;
  background: url('../../../public/img/homepage/header_free-job-posting.png');
  background-size: cover;
  margin-top: 70px;

  .container {
    height: 70vh;
    flex-wrap: wrap;

    h1 {
      color: #fff;
      font-size: 2.5rem;
      width: 100%;

      span {
        display: block;
      }
    }
  }
}

.jobs {
  padding: 60px 0;

  h3 {
    font-family: $font-family-sans-lato;
    font-weight: 700;
    font-size: 21px;
    color: #575757;
    margin: 20px 0 12px 0;
  }

  .list-unstyled {
    font-family: $font-family-sans-lato;
    color: #575757;
    li {
      display: flex;
      margin: 0 0 12px 12px;

      &.first {
        margin-left: 0;
        list-style-type: none;
      }
      .icon {
        margin-right: 10px;
      }
      i {
        color: #f26622;
        font-size: 14px;
      }
    }
  }

  .btn-secondary {
    font-size: 18px;
    padding: 8px 22px;
    margin-top: 12px;

    &:nth-of-type(2) {
      background: #424242 !important;
      border-color: #424242 !important;
    }
  }
}

.mid-section {
  padding: 80px 0;
  background: hsl(23, 100%, 47%);
  color: #fff;
  margin-bottom: 40px;

  h2 {
    text-align: center;
    text-transform: uppercase;
    margin-bottom: 30px;
    position: relative;

    img {
      margin: -12px 10px 0 0;
    }
  }

  p {
    text-align: center;
    color: #fff;
  }

  .btn-secondary {
    background: #424242;
    border-color: #424242;
    margin: 30px 0 0 0;
    padding: 8px 25px;
    font-size: 18px;
  }
}

.statistics {
  padding: 20px 0 30px 0;

  h2 {
    margin-bottom: 30px;
  }

  .list-inline {
    margin: 0;
    font-family: $font-family-sans-lato;
    flex-wrap: wrap;

    li {
      width: 20%;
      text-align: center;
      font-size: 16px;
      border: 1px solid rgba(0, 0, 0, 0.02);
      width: 105px;
      height: 105px;
      color: #888;
      border-radius: 6px;
      -webkit-box-shadow: 0px 15px 35px #0000000d;
      box-shadow: 0px 15px 35px #0000000d;
      background: #fff;

      .text {
        width: 100%;

        span {
          display: block;
          margin: 4px auto;
          font-weight: 700;
          color: #575757;
        }

        i {
          display: block;
          font-size: 41px;
        }

        img {
          width: 42px;
          height: 42px;
        }
      }
    }
  }
}

@media only screen and (max-width: 768px) {
  .main-header {
    height: 50vh;

    .container {
      height: 50vh;
      padding: 30px 20px;

      h1 {
        font-size: 2rem;
      }
    }
  }
}

@media only screen and (max-width: 576px) {
  .main-header {
    margin-top: 60px;
  }

  .btn-secondary {
    font-size: 18px;
    padding: 8px 22px;
    margin-top: 12px;
    width: 100%;
    display: block;

    &:nth-of-type(2) {
      background: #424242 !important;
      border-color: #424242 !important;
      margin-left: 0 !important;
    }
  }
}
</style>
